<template>
  <div class="page" style="background-color:#F9F9F9">
     <div class="box-top"><span style="font-size: 40px;color: white;font-weight: bold;margin-top: -50px;">年检介绍</span></div>
     <div style="margin: 12px;position: relative;top: -60px">
        <div class="box-part1">
            <div style="display: flex;flex-flow: row;align-items: center;justify-content: center;padding: 15px 0px 17px 0px;">
              <van-icon name="/images/question2.png" size="20" style="margin-left: 10px;margin-right: 6px;"/>
              <div style="font-size: 17px;">年检是什么</div>
            </div>
            <div style="padding-left: 12px;padding-right: 12px;line-height: 24px;font-size: 15px;">
              根据《中华人民共和国道路交通安全法实施条例》第十六条规定，<span style="color: #2f80ed">机动车应当从注册之日起，按期进行安全技术检验，</span>及时消除车辆安全隐患，督促加强汽车的维护保养，减少交通事故的发生。
            </div>
        </div>

       <div class="box-part2">
           <div style="display: flex;flex-flow: row;align-items: center;justify-content: center;margin-top: 15px;">
             <van-icon name="/images/inspec_type.png" size="20" style="margin-left: 10px;margin-right: 6px;"/>
             <div style="font-size: 17px;">年检类型</div>
           </div>
           <div style="text-align: center;margin-top: 15px;font-size: 15px;color: #464545;">
             办理要求及办理条件以当地要求及条件为准
           </div>
       </div>

       <div class="box-part3">
           <div style="padding: 10px 0px 3px 10px;font-size: 16px;color: white;">
              6年免检（免检标申领）
           </div>
           <div style="padding: 10px 10px 10px 10px;font-size: 15px;color: white;line-height: 21px;">
             6年免检是指6年内，每两年进行一次检验周期的车辆不上线检测，私家小型客车需要每2年定期检验交强险手续。6年内车辆需要在第二年、第四年进行免检标申请。
           </div>

           <div style="background-color: #ECF4FF;font-size: 16px;padding: 14px 10px 10px 16px;border-top-left-radius: 25px;margin-top: 10px;">
             <div style="color: #999999">免检满足条件</div>
             <div style="margin-top: 14px;font-size: 15px;">
                 <div class="exemption_conditions">
                   <van-icon name="/images/select.png" size="17" style="margin-right: 4px;"/>
                   <div>行驶证注册日期距离当前日期6年内</div>
                 </div>
                 <div class="exemption_conditions">
                   <van-icon name="/images/select.png" size="17" style="margin-right: 4px;"/>
                   <div>9座及以下非营运小型客车</div>
                 </div>
                 <div class="exemption_conditions">
                   <van-icon name="/images/select.png" size="17" style="margin-right: 4px;"/>
                   <div>未发生过人身伤亡事故</div>
                 </div>
                 <div class="exemption_conditions">
                   <van-icon name="/images/select.png" size="17" style="margin-right: 4px;"/>
                   <div>交强险保单在有效期内</div>
                 </div>
                 <div class="exemption_conditions">
                   <van-icon name="/images/select.png" size="17" style="margin-right: 4px;"/>
                   <div>车辆无违章</div>
                 </div>
             </div>
           </div>
       </div>


       <div class="box-part4">
         <div style="padding: 10px 0px 3px 10px;font-size: 16px;color: white;">
           检车站年检（上线检测）
         </div>
         <div style="padding: 10px 10px 10px 10px;font-size: 15px;color: white;line-height: 21px;">
           上线检测指将年检车辆开到检测站进行上检测线检车，检测合格后由检测站统一发放年检标。不满足新车免检条件的车辆都需要办理上线检测。 检测过程中，检测站会收取一定的费用，具体以检测站实际收费为准。
         </div>

         <div style="background-color: #FEF7ED;font-size: 16px;padding: 14px 10px 10px 16px;border-top-left-radius: 25px;margin-top: 10px;">
           <div style="color: #999999">上线检满足条件</div>
           <div style="margin-top: 14px;font-size: 15px;">
             <div class="exemption_conditions">
               <van-icon name="/images/select2.png" size="17" style="margin-right: 4px;"/>
               <div>车辆无改装，车辆外观、灯光完好</div>
             </div>
             <div class="exemption_conditions">
               <van-icon name="/images/select2.png" size="17" style="margin-right: 4px;"/>
               <div>车身颜色与行驶证照片相符</div>
             </div>
             <div class="exemption_conditions">
               <van-icon name="/images/select2.png" size="17" style="margin-right: 4px;"/>
               <div>交强险保单在有效期内</div>
             </div>
             <div class="exemption_conditions">
               <van-icon name="/images/select2.png" size="17" style="margin-right: 4px;"/>
               <div>车辆违章或交通事故处理完毕</div>
             </div>
           </div>
         </div>
       </div>


     </div>
  </div>
</template>
<script>



export default {
  name: "introduce",
  data() {
    return {

    }
  },
  methods: {

  },

}
</script>

<style scoped>
.box-top {
  height: 140px;
  background: linear-gradient(#56ccf2, #2f80ed);
  display: flex;
  height: 140px;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.box-part1{
  height: 140px;
  background: #ffffff;
  border-radius: 10px;
  padding-bottom: 18px;
}

.box-part3{
  margin-top: 15px;
  border-radius: 10px;
  background: linear-gradient(to right, #3D96FA, #6CAEFC);
}

.exemption_conditions {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.box-part4{
  margin-top: 15px;
  border-radius: 10px;
  background: linear-gradient(to right, #FF913C, #FFAE6F);;
}
</style>
